export const GET_RESULTS_SUCCESS = 'GET_RESULTS_SUCCESS';
export const SEARCH_RESULTS_SUCCESS = 'SEARCH_RESULTS_SUCCESS';
export const SEARCH_ENTITY_RESULTS_LOAD_MORE_SUCCESS = 'SEARCH_ENTITY_RESULTS_LOAD_MORE_SUCCESS';
export const GET_ALL_COULMNS_SEARCH_SUCCESS = 'GET_ALL_COULMNS_SEARCH_SUCCESS';
export const SET_SEARCH_BY_COLUMNS_HEADERS = 'SET_SEARCH_BY_COLUMNS_HEADERS';
export const SET_SEARCH_BY_COLUMN_HEADER_DISPLAY = 'SET_SEARCH_BY_COLUMN_HEADER_DISPLAY';
export const SET_SEARCH_CRITERIAS = 'SET_SEARCH_CRITERIAS';
export const INIT_SEARCH_DISPLAY_FIELDS = 'INIT_SEARCH_DISPLAY_FIELDS';
export const ADD_SEARCH_HEADER_DISPLAY = 'ADD_SEARCH_HEADER_DISPLAY';
export const REMOVE_SEARCH_HEADER_DISPLAY = 'REMOVE_SEARCH_HEADER_DISPLAY';
export const SET_SEARCH_HEADER_DISPLAY = 'SET_SEARCH_HEADER_DISPLAY';

export const INIT_SEARCH_CRITERIEAS = 'INIT_SEARCH_CRITERIEAS';
export const ADD_SEARCH_CRITERIEA = 'ADD_SEARCH_CRITERIEA';
export const REMOVE_SEARCH_CRITERIEA = 'REMOVE_SEARCH_CRITERIEA';
export const UPDATE_SEARCH_CRITERIEA = 'UPDATE_SEARCH_CRITERIEA';
export const SET_SITES_BY_USER_LOGGED_IN = 'SET_SITES_BY_USER_LOGGED_IN';
